import React from "react";
import { HInput, passParamsThrough } from "../../../../validation/HForm";

const InputField = ({
  name,
  id,
  decimals,
  readOnly,
  onClick,
  control,
  register,
  errors,
}) => {
  const props = { control, register, errors };
  return passParamsThrough(
    <div className="form-element-data number">
      <HInput
        h="true"
        className="input"
        type="text"
        name={name}
        id={id}
        decimals={decimals}
        readOnly={readOnly}
        onClick={onClick}
      />
    </div>,
    props
  );
};

export default InputField;
